var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2 mt-md-0 font-weight-normal"},[(_vm.startDate == _vm.endDate)?_c('p',[_vm._v(_vm._s(_vm.$t('date'))+" "+_vm._s(_vm.startDate))]):_c('p',[_vm._v(_vm._s(_vm.$t('date'))+" "+_vm._s(_vm.startDate)+" "+_vm._s(_vm.$t('to'))+" "+_vm._s(_vm.endDate))])])
}
var staticRenderFns = []

export { render, staticRenderFns }